import React from "react";
import sharePlaceholderImage from "../../assets/share.png";
import styles from "./ShareCard.module.css";

const isAndroid = () => {
	const ua = navigator.userAgent.toLowerCase();
	const isAndroid = ua.indexOf("android") > -1;
	if (isAndroid) {
		return true;
	} else {
		return false;
	}
};

const share = () => {
	const appLink = "https://apps.apple.com/bg/app/betway-scores-football-news/id1552348455";
	const appLinkAndroid = "https://play.google.com/store/apps/details?id=com.betway.scores.android&pcampaignid=web_share";

	const iOSTitle = "Download BetwayScores";
	const androidTitle = "Download BetwayScores";
	const shareBody = "Download BetwayScores and compete against your friends in BW Fantasy!";
	const shareBodyAndroid = "Download BetwayScores and compete against your friends in BW Fantasy!";

	if (navigator.share) {
		// iOS and modern browsers with Web Share API support
		navigator
			.share({
				title: iOSTitle,
				text: shareBody,
				url: appLink,
			})
			.then(() => console.log("Successfully shared"))
			.catch((error) => console.error("Error sharing:", error));
	} else if (isAndroid()) {
		// Android WebView
		try {
			// First try the shareData method if it exists
			// @ts-expect-error - TS doesn't know that Android is a global object passed from the Android app
			if (window.Android && typeof window.Android.shareData === "function") {
				window.Android.shareData(androidTitle, shareBodyAndroid, appLinkAndroid);
				console.log("Successfully shared via Android.shareData");
			}
			// Fallback to openExternal with share intent if shareData is not available
			else if (window.Android && typeof window.Android.openExternal === "function") {
				// Create Android share intent URL
				const shareText = `${shareBodyAndroid} ${appLinkAndroid}`;
				const shareIntentUrl = `intent://send?type=text/plain&text=${encodeURIComponent(shareText)}#Intent;scheme=android-app;package=android;end`;

				window.Android.openExternal(shareIntentUrl);
				console.log("Successfully shared via Android share intent");
			} else {
				console.warn("Android share interface not available - neither shareData nor openExternal methods found");
			}
		} catch (error) {
			console.error("Error sharing on Android:", error);
			console.warn("Android share functionality failed - native share drawer could not be opened");
		}
	} else {
		console.warn("Web share not supported - native share drawer not available on this platform");
	}
};

const ShareCard = () => {
	return (
		<div className={styles.card}>
			<img src={sharePlaceholderImage} alt="Friends looking at phone" className={styles.image} />
			<div className={styles.contentContainer}>
				<h2 className={styles.title}>Invite Your Friends to Play</h2>
				<p className={styles.description}>
					Invite your friends to Play BW Fantasy Football to see who of you is the best football manager, and for you to all stand a chance
					of winning weekly prizes!
				</p>
				<button
					className={styles.button}
					onClick={() => {
						share();
					}}
				>
					Invite Friends
				</button>
			</div>
		</div>
	);
};

export default ShareCard;
